/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {LegalEntityCompanyDTO} from '../model/LegalEntityCompanyDTO';
import {LegalEntityCompanyPostRequestDTO} from '../model/LegalEntityCompanyPostRequestDTO';
import {LegalEntityParentCompanyDTO} from '../model/LegalEntityParentCompanyDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* LegalEntityCompanyServices service.
* @module api/LegalEntityCompanyServicesApi
* @version v0
*/
export class LegalEntityCompanyServicesApi {

    /**
    * Constructs a new LegalEntityCompanyServicesApi. 
    * @alias module:api/LegalEntityCompanyServicesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the deleteLegalEntityCompanyById operation.
     * @callback moduleapi/LegalEntityCompanyServicesApi~deleteLegalEntityCompanyByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete Legal Entity Company
     * Request to delete a Legal Entity Company given the id.
     * @param {Number} legalEntityCompanyId 
     * @param {module:api/LegalEntityCompanyServicesApi~deleteLegalEntityCompanyByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteLegalEntityCompanyById(legalEntityCompanyId, callback) {
      
      let postBody = null;
      // verify the required parameter 'legalEntityCompanyId' is set
      if (legalEntityCompanyId === undefined || legalEntityCompanyId === null) {
        throw new Error("Missing the required parameter 'legalEntityCompanyId' when calling deleteLegalEntityCompanyById");
      }

      let pathParams = {
        'legalEntityCompanyId': legalEntityCompanyId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-company/{legalEntityCompanyId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getLegalEntityCompanyById operation.
     * @callback moduleapi/LegalEntityCompanyServicesApi~getLegalEntityCompanyByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LegalEntityCompanyDTO{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Legal Entity Company by id
     * Request to get a Legal Entity Company by its id.
     * @param {Number} legalEntityCompanyId 
     * @param {module:api/LegalEntityCompanyServicesApi~getLegalEntityCompanyByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getLegalEntityCompanyById(legalEntityCompanyId, callback) {
      
      let postBody = null;
      // verify the required parameter 'legalEntityCompanyId' is set
      if (legalEntityCompanyId === undefined || legalEntityCompanyId === null) {
        throw new Error("Missing the required parameter 'legalEntityCompanyId' when calling getLegalEntityCompanyById");
      }

      let pathParams = {
        'legalEntityCompanyId': legalEntityCompanyId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = LegalEntityCompanyDTO;

      return this.apiClient.callApi(
        '/api/legal-entity-company/{legalEntityCompanyId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getLegalEntityCompanyMonitor operation.
     * @callback moduleapi/LegalEntityCompanyServicesApi~getLegalEntityCompanyMonitorCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/LegalEntityParentCompanyDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get monitor of Legal Entity Company
     * Request to get the list of all the Legal Entity Subsidiaries with the respective Legal Entity Parent Company and subsidiary.
     * @param {module:api/LegalEntityCompanyServicesApi~getLegalEntityCompanyMonitorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getLegalEntityCompanyMonitor(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [LegalEntityParentCompanyDTO];

      return this.apiClient.callApi(
        '/api/legal-entity-company/monitor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the newLegalEntityCompany operation.
     * @callback moduleapi/LegalEntityCompanyServicesApi~newLegalEntityCompanyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create new Legal Entity Company
     * Request to add a new Legal Entity Company.
     * @param {module:model/LegalEntityCompanyPostRequestDTO} body 
     * @param {module:api/LegalEntityCompanyServicesApi~newLegalEntityCompanyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    newLegalEntityCompany(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling newLegalEntityCompany");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-company', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateLegalEntityCompany operation.
     * @callback moduleapi/LegalEntityCompanyServicesApi~updateLegalEntityCompanyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RestBodyResponseUtil{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Legal Entity Company
     * Request to update Legal Entity Company
     * @param {module:model/LegalEntityCompanyPostRequestDTO} body 
     * @param {Number} legalEntityCompanyId 
     * @param {module:api/LegalEntityCompanyServicesApi~updateLegalEntityCompanyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateLegalEntityCompany(body, legalEntityCompanyId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateLegalEntityCompany");
      }
      // verify the required parameter 'legalEntityCompanyId' is set
      if (legalEntityCompanyId === undefined || legalEntityCompanyId === null) {
        throw new Error("Missing the required parameter 'legalEntityCompanyId' when calling updateLegalEntityCompany");
      }

      let pathParams = {
        'legalEntityCompanyId': legalEntityCompanyId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = RestBodyResponseUtil;

      return this.apiClient.callApi(
        '/api/legal-entity-company/{legalEntityCompanyId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}